module.exports = require("./yue-Hans.d.ts");